export const imageDisplaySize = { width:600, height:800 };
export const styles = {
    inputFile: {
		display: 'none'
	},

    imageContainer: {
        width: imageDisplaySize.width,
        height: imageDisplaySize.height,
        marginTop: 10,
        border: '1px solid lightgray',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
};